import { apiGet, apiPut } from './apiClient';

export const FEATURED_VENUES_DOC_ID = 'venues';
export const MAX_FEATURED_VENUES = 6;

export async function getFeaturedVenueIds() {
  try {
    const data = await apiGet(`featureds/${FEATURED_VENUES_DOC_ID}`);
    const venues = Array.isArray(data?.venues) ? data.venues : [];
    return venues.filter((id) => typeof id === 'string' && id.trim());
  } catch (err) {
    if (err?.status === 404) return [];
    throw err;
  }
}

/** Upsert — doc yoksa update servisi create eder */
export async function saveFeaturedVenueIds(venueIds) {
  const unique = [...new Set((venueIds || []).filter(Boolean))];
  if (unique.length > MAX_FEATURED_VENUES) {
    const error = new Error(
      `En fazla ${MAX_FEATURED_VENUES} mekan öne çıkarılabilir`,
    );
    error.status = 400;
    throw error;
  }
  return apiPut(`featureds/${FEATURED_VENUES_DOC_ID}`, {
    id: FEATURED_VENUES_DOC_ID,
    venues: unique,
  });
}

export async function toggleFeaturedVenue(venueId, currentlyFeatured, currentIds) {
  let next;
  if (currentlyFeatured) {
    next = currentIds.filter((id) => id !== venueId);
  } else {
    if (currentIds.length >= MAX_FEATURED_VENUES) {
      const error = new Error(
        `En fazla ${MAX_FEATURED_VENUES} mekan öne çıkarılabilir`,
      );
      error.status = 400;
      throw error;
    }
    next = [...currentIds, venueId];
  }
  await saveFeaturedVenueIds(next);
  return next;
}
